// Preço é dado, não texto.
//
// A landing anunciou um valor durante meses enquanto o Stripe cobrava
// outro, porque o preço estava escrito à mão no texto de várias telas e
// ninguém lembrou de mudá-las quando ele mudou no admin.
//
// A regra agora é esta: nenhum preço aparece na tela sem ter vindo de
// /api/plans. Quando a API ainda não respondeu, a frase é mostrada sem a
// parte do preço — uma promessa a menos é melhor do que um valor que não é
// o que será cobrado.

export const MARCADOR = "{preco}";

/** Troca {preco} pelo valor; devolve null quando não há preço para mostrar. */
export function aplicarPreco(modelo, preco) {
  if (!modelo || !preco) return null;
  return modelo.split(MARCADOR).join(preco);
}

/** O texto com preço quando ele existe, senão a versão sem preço. */
export function frasePreco(modeloComPreco, preco, fraseSemPreco) {
  return aplicarPreco(modeloComPreco, preco) ?? fraseSemPreco;
}
